/**
 * Describes whether discretionay price is static or floats
 * tag: 841
 * @readonly
 * @enum {number} (int)
 */
export enum DiscretionMoveType {
  /** Floating (default) */
  Floating = 0,
  /** Fixed */
  Fixed = 1,
}
